import config from '@/config';

type TokenResponse = { access_token: string };

const getSalesforceToken = async () => {
  const salesforceResponse = await fetch(
    `${config.salesforce.baseUrl}/oauth2/token`,
    {
      method: 'POST',
      body: new URLSearchParams({
        grant_type: 'refresh_token',
        refresh_token: config.salesforce.refreshToken,
        client_id: config.salesforce.clientId,
        client_secret: config.salesforce.clientSecret,
      }),
    }
  );
  if (!salesforceResponse.ok)
    throw new Error('Could not authenticate to Salesforce');
  const responseBody = (await salesforceResponse.json()) as TokenResponse;
  return responseBody.access_token;
};

export const submitForm = async (
  formType: string,
  formData: Record<string, unknown>
): Promise<Response> => {
  const accessToken = await getSalesforceToken();
  const salesforceResponse = await fetch(
    `${config.salesforce.baseUrl}/apexrest/api/v1/forms`,
    {
      method: 'POST',
      headers: {
        Authorization: `Bearer ${accessToken}`,
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        formType,
        ...formData,
      }),
    }
  );
  if (!salesforceResponse.ok)
    throw new Error('Could not send form to Salesforce');

  return salesforceResponse;
};

export const isValidSalesforceId = (str: string): boolean =>
  /^[a-zA-Z0-9]{15}|[a-zA-Z0-9]{18}$/u.test(str);

export type SalesforceApplicantInfo = Partial<{
  // First Name of the Admissions Rep the Applicant got assigned to
  admissionsRepFirstName: string;

  // Last Name of the Admissions Rep the Applicant got assigned to
  admissionsRepLastName: string;

  // Phone number (prefix included) from which Admissions will be trying to
  // reach out to the Applicant
  callFromNumber: string;

  // URL to schedule the Personal Interview
  personalInterviewUrl: string;

  // URL for visiting the new pre-student portal
  yourIronhackUrl: string;
}>;

export type SalesforceFormResponse = {
  // When a form submission generates an applicant, this property contains
  // different information based on the scenario
  applicantInfo: SalesforceApplicantInfo;

  // Id of the created form submission in Salesforce
  id: string;

  status: 'OK';
};

export type SalesforcePublicResponse = Pick<
  SalesforceFormResponse,
  'applicantInfo'
>;
